import { render, staticRenderFns } from "./CsrResubmit.vue?vue&type=template&id=6b49ca74"
import script from "./CsrResubmit.vue?vue&type=script&lang=js"
export * from "./CsrResubmit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports